import LightBoxGallery from './LightBoxGallery';

export default LightBoxGallery;
